// extracted by mini-css-extract-plugin
export var bubble = "_12-0";
export var container = "_12-f";
export var contrastBorder = "_12-g";
export var greyOut = "_12-2";
export var initialsColor0 = "_12-3";
export var initialsColor1 = "_12-4";
export var initialsColor10 = "_12-d";
export var initialsColor11 = "_12-e";
export var initialsColor2 = "_12-5";
export var initialsColor3 = "_12-6";
export var initialsColor4 = "_12-7";
export var initialsColor5 = "_12-8";
export var initialsColor6 = "_12-9";
export var initialsColor7 = "_12-a";
export var initialsColor8 = "_12-b";
export var initialsColor9 = "_12-c";
export var initialsWrapper = "_12-1";
export var large = "_12-l";
export var medium = "_12-k";
export var mediumSmall = "_12-j";
export var mediumSmallMedium = "_12-o";
export var micro = "_12-h";
export var small = "_12-i";
export var tiny = "_12-n";
export var xTiny = "_12-m";